import { useState } from 'react';
import clsx from 'clsx';

import { WorkOrderAssetTreeType, WorkOrderDetailType } from '@atom/types/work';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';
import {
  Client,
  isCurrentClient,
} from '@atom/utilities/featureToggleUtilities';

import WorkOrderAssetTree from './workOrderAssetTree/WorkOrderAssetTree';
import WorkOrderElementView from './workOrderElementView/WorkOrderElementView';
import WorkOrderAssetHeader from './WorkOrderAssetHeader';
import WorkOrderAssetViewContext from './WorkOrderAssetViewContext';

import classes from './workOrderAssetView.module.css';

interface Props {
  workOrderDetail: WorkOrderDetailType;
  workOrderAsset: WorkOrderAssetTreeType;
  setActiveWorkOrderAsset: Function;
  refetchWorkOrderAssetTreeLoading: boolean;
  refetchWorkOrderAssetTree: () => void;
  refetch: () => void;
  previewView?: boolean;
  taskId?: string;
}

const WorkOrderAssetView = ({
  workOrderDetail,
  workOrderAsset,
  setActiveWorkOrderAsset,
  refetchWorkOrderAssetTreeLoading,
  refetchWorkOrderAssetTree,
  refetch,
  previewView = false,
  taskId,
}: Props) => {
  const [activeElementId, setActiveElementId] = useState<string>(
    workOrderAsset.id,
  );
  const [hasUnsavedChanges, setUnsavedChanges] = useState<boolean>(false);

  const canAddAsset = isCurrentClient([Client.UDOT_TMD, Client.ARDOT])
    ? hasRolePermissions(ROLE_SETS.ORG_ADMIN)
    : true;

  return (
    <WorkOrderAssetViewContext.Provider
      value={{
        workOrderDetail,
        workOrderAsset,
        setActiveWorkOrderAsset,
        refetchWorkOrderAssetTreeLoading,
        refetchWorkOrderAssetTree,
        refetch,
        activeElementId,
        setActiveElementId,
        previewView,
        hasUnsavedChanges,
        setUnsavedChanges,
        taskId,
        canAddAsset,
      }}
    >
      <div className={classes.workOrderAssetContainer}>
        <WorkOrderAssetHeader />
        <div className={classes.workOrderContent}>
          <div className={clsx(classes.pane, classes.left)}>
            <WorkOrderAssetTree />
          </div>
          <div className={clsx(classes.pane, classes.right)}>
            <WorkOrderElementView />
          </div>
        </div>
      </div>
    </WorkOrderAssetViewContext.Provider>
  );
};

export default WorkOrderAssetView;
